import { computed, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Subject } from 'rxjs';

export interface AppConfig {
  inputStyle: string;
  colorScheme: string;
  theme: string;
  ripple: boolean;
  menuMode: string;
  scale: number;
  menuTheme: string;
}

interface LayoutState {
  staticMenuDesktopInactive: boolean;
  overlayMenuActive: boolean;
  configSidebarVisible: boolean;
  staticMenuMobileActive: boolean;
  menuHoverActive: boolean;
  searchBarActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public config$ = new BehaviorSubject<AppConfig>({
    ripple: false,
    inputStyle: 'outlined',
    menuMode: 'static',
    colorScheme: 'light',
    theme: 'blue',
    menuTheme: 'darkgray',
    scale: 12,
  });
  public readonly config = toSignal(this.config$, { initialValue: this.config$.getValue() });

  public state: LayoutState = {
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    searchBarActive: false,
  };

  public readonly rightMenuVisible = signal(false);

  private readonly configUpdate = new Subject<AppConfig>();
  private readonly overlayOpen = new Subject<null>();

  public configUpdate$ = this.configUpdate.asObservable();
  public overlayOpen$ = this.overlayOpen.asObservable();

  public isOverlay = computed(() => this.config().menuMode === 'overlay');
  public isSlim = computed(() => this.config().menuMode === 'slim');
  public isCompact = computed(() => this.config().menuMode === 'compact');
  public isHorizontal = computed(() => this.config().menuMode === 'horizontal');

  public onMenuToggle() {
    if (this.isOverlay()) {
      this.state.overlayMenuActive = !this.state.overlayMenuActive;

      if (this.state.overlayMenuActive) {
        this.overlayOpen.next(null);
      }
    }

    if (this.isDesktop()) {
      this.state.staticMenuDesktopInactive = !this.state.staticMenuDesktopInactive;
    } else {
      this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive;

      if (this.state.staticMenuMobileActive) {
        this.overlayOpen.next(null);
      }
    }
  }

  public onOverlaySubmenuOpen() {
    this.overlayOpen.next(null);
  }

  public showRightMenu() {
    this.rightMenuVisible.set(true);
  }

  public showConfigSidebar() {
    this.state.configSidebarVisible = true;
  }

  public toggleSearchBar() {
    this.state.searchBarActive = !this.state.searchBarActive;
  }

  public isDesktop() {
    return window.innerWidth > 991;
  }

  public isMobile() {
    return !this.isDesktop();
  }

  public onConfigUpdate() {
    // this.configUpdate.next(this.config);
  }
}
